module.exports = {
  title: 'Liquid Glass Playground',
  author: 'Enzo Manuel Mangano',
  date: '2025-11-24',
  slug: 'liquid-glass-playground',
  tags: ['reanimated', 'gesture-handler'],
};
